import React from "react";
import { Icons } from "../../config/MuiIcons.config";
import MUITextField from "../MUITextField/MUITextField";

const MUITableSearch = ({ SearchText, HandleSearch, CancelSearch }) => {
  return (
    <MUITextField
      type="text"
      placeholder="Search"
      value={SearchText || ""}
      onChange={HandleSearch}
      starticon={<Icons.Search className="me-1" />}
      endicon={
        SearchText ? (
          <Icons.Close onClick={CancelSearch} className="cursor-pointer ms-1" />
        ) : null
      }
    />
  );
};

export default MUITableSearch;
